import type { AccordionContainerBlock } from '~/types/storyblok/accordion-container-block'
import type { Story } from '~/types/vendors/storyblok'

export interface AccordionContainer {
  _uid: string
  accordionBlocks: any[]
  component: 'accordion-container-block'
}

export type AccordionContainerMap = Map<string, AccordionContainer>

export function normalizeAccordionContainer(
  stories?: Story<AccordionContainerBlock>[],
): AccordionContainerMap {
  const map = new Map<string, AccordionContainer>()

  if (!stories)
    return map

  stories
    .filter(({ name }) => name !== 'no-faq')
    .forEach((story) => {
      const { content, uuid } = story
      if (!content)
        return

      const accordion: AccordionContainer = {
        _uid: uuid,
        accordionBlocks: content.accordionBlocks || [],
        component: content.component,
      }

      map.set(uuid, accordion)
    })

  return map
}
